import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_REQUEST = 'DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_REQUEST';
export const DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_SUCCESS = 'DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_SUCCESS';
export const DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_FAILURE = 'DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_FAILURE';

export type WorkedInLast30DaysExcelState = DefaultState;

interface WorkedInLast30DaysExcelRequest {
  type: typeof DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_REQUEST;
};

interface WorkedInLast30DaysExcelSuccess {
  type: typeof DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_SUCCESS,
}

interface WorkedInLast30DaysExcelFailure {
  type: typeof DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_FAILURE;
}

export type WorkedInLast30DaysExcelActionTypes = WorkedInLast30DaysExcelRequest | WorkedInLast30DaysExcelSuccess | WorkedInLast30DaysExcelFailure;